// extracted by css-extract-rspack-plugin
export default {"container":"gpWHSUTt9lEZ8ouE"};